/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Plans_Team_TitleInputs */

const es_components_upgrade_plan_modal_plans_team_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const en_components_upgrade_plan_modal_plans_team_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Components_Upgrade_Plan_Modal_Plans_Team_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_plans_team_title = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Plans_Team_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Plans_Team_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_plans_team_title(inputs)
	return en_components_upgrade_plan_modal_plans_team_title(inputs)
});
export { components_upgrade_plan_modal_plans_team_title as "components.upgrade_plan_modal.plans.team.title" }